export const AUTH_TOKEN = "auth_token";
export const REFRESH_TOKEN = "ref_token";
export const USER_DATA = "user_data";
